<template lang="pug">
    .container
      button(:class="tipo" @click="tratarAcao" :disabled="desabilitado") 
        i(v-if="icone && posicaoIcone === 'esquerda'" :class="icone" class="icone icone-esquerda")
        span {{ titulo }}
        i(v-if="icone && posicaoIcone === 'direita'" :class="icone" class="icone icone-direita")
</template>
  
  <script>
  export default {
    name: 'BotaoComponent',
    props: {
      tipo: {
        type: String,
        required: false,
        default: 'padrao',
        validator: value => ['primario', 'secundario', 'padrao', 'limpar'].includes(value)
      },
      titulo: {
        type: String,
        required: true
      },
      acao: {
        type: Function,
        required: true
      },
      icone: {
        type: String,
        required: false
      },
      posicaoIcone: {
        type: String,
        required: false,
        default: 'esquerda',
        validator: value => ['esquerda', 'direita'].includes(value)
      },
      desabilitado: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    computed: {
      botaoClasse() {
        return this.tipo === 'primario' ? 'primario' : 'secundario';
      }
    },
    methods: {
      tratarAcao() {
        if (!this.desabilitado) {
          this.acao();
        }
      }
    }
  }
  </script>
  
  <style scoped lang="scss">
  @import '@/styles/variaveis.scss';
  
  button {
    display: flex;
    justify-content: center;
    align-items: space-between;
    flex-direction: row;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
    font-size: 14px;
    border-radius: 4px;
    transition: background-color 0.3s, box-shadow 0.3s;
    margin-left: 10px;
  }

  button:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
  
  .primario {
    display: flex;
    align-items: center;
    background-color: $primary-color;
    color: $white;
  }
  
  .secundario {
    display: flex;
    align-items: center;
    background-color: $default-color;
    color: $black;
  }

  .padrao {
    display: flex;
    align-items: center;
    background-color: $white;
    border: 1px solid $black;
    color: $black;
  }
  
  .primario:hover:not(:disabled) {
    background-color: darken($primary-color, 10%);
  }
  
  .secundario:hover {
    background-color: darken($default-color, 10%);
  }

  .padrao:hover {
    background-color: darken($white, 10%);
  }

  .limpar {
    display: flex;
    align-items: center;
    background-color:  $alto;
    color: $mine-shaft;
  }

  .limpar:hover {
    background-color: darken($alto, 5%);
  }

  button:active:not(:disabled) {
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    transform: translateY(2px);
  }

  .icone {
    padding: 0;
    margin: 0;
  }

  .icone-esquerda {
    margin-left: -8px;
    margin-right: 8px;
  }

  .icone-direita {
    margin-right: -8px;
    margin-left: 8px;
  }
  </style>